import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=f4685322&scoped=true&"
import script from "./dictionaries.vue?vue&type=script&lang=js&"
export * from "./dictionaries.vue?vue&type=script&lang=js&"
import style0 from "./dictionaries.vue?vue&type=style&index=0&id=f4685322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4685322",
  null
  
)

export default component.exports